<template>
<div>



  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Fees List</h3>
          <span class="float-right">
            <button type="button" class="btn btn-sm btn-primary float-right" @click="editModal(softwareTimings)" > <i class="fa fa-pencil"></i></button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <div class="row">
            <div class="col-4">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Member Fees Details</h3>
                  <span class="float-right">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      data-toggle="modal"
                      data-target="#modal-xl"
                    >
                      <i class="fa fa-pencil"></i></button
                  ></span>
                </div>
                <!-- /.card-header -->
                <table class="table table-sm">
                  <tr>
                    <th>Member Fees</th>
                    <th>{{ fees.memberFee }}</th>
                  </tr>
                  <tr>
                    <th>Member Fees Type</th>
                    <th>{{ fees.memberFeeType }}</th>
                  </tr>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-4">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Employee/Agent Fees Details</h3>
                  <span class="float-right">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      data-toggle="modal"
                      data-target="#modal-xl"
                    >
                      <i class="fa fa-pencil"></i></button
                  ></span>
                </div>
                <!-- /.card-header -->
                <table class="table table-sm">
                  <tr>
                    <th>Employee/Agent Fees</th>
                    <th>{{ fees.agentFee }}</th>
                  </tr>
                  <tr>
                    <th>Employee/Agent Fees Type</th>
                    <th>{{ fees.agentFeeType }}</th>
                  </tr>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-4">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">File Charge</h3>
                  <span class="float-right">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      data-toggle="modal"
                      data-target="#modal-xl"
                    >
                      <i class="fa fa-pencil"></i></button
                  ></span>
                </div>
                <!-- /.card-header -->
                <table class="table table-sm">
                  <tr>
                    <th>Per File Charge</th>
                    <th>{{ fees.fileCharge }}</th>
                  </tr>
                  <tr>
                    <th>Per File Charge Type</th>
                    <th>{{ fees.fileChargeType }}</th>
                  </tr>
                </table>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
            </div>
            <!-- /.col -->
          </div>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of Fees
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>
    

 
      <!-- /.row -->
      <div class="modal fade" id="modal-xl">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Master Fees Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="col-md-12">
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <form role="form">
                      <div class="row">
                        <div class="col-4">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >Member Fees <span class="red">*</span></label
                            >
                            <input
                              v-model="form.memberFee"
                              type="text"
                              name="memberFee"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('memberFee'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="memberFee"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-4">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >Member Fees Type
                              <span class="red">*</span></label
                            >
                            <select
                              v-model="form.memberFeeType"
                              name="memberFeeType"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('memberFeeType'),
                              }"
                            >
                              <option value="fixed">Fixed</option>
                              <option value="percent">Percent</option>
                            </select>
                            <has-error
                              :form="form"
                              field="memberFeeType"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!--/.col (right) -->
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-success">SAVE</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CANCEL
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="modal-xl1">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Master Fees Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="col-md-12">
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <form role="form">
                      <div class="row">
                        <div class="col-4">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Agent Fees <span class="red">*</span></label>
                            <input
                              v-model="form.agentFee"
                              type="text"
                              name="agentFee"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('agentFee'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="agentFee"
                            ></has-error>
                          </div>
                        </div>
                        <div class="col-4">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >Agent Fee Type <span class="red">*</span></label
                            >
                            <select
                              v-model="form.agentFeeType"
                              name="agentFeeType"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('agentFeeType'),
                              }"
                            >
                              <option value="fixed">Fixed</option>
                              <option value="percent">Percent</option>
                            </select>
                            <has-error
                              :form="form"
                              field="agentFeeType"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!--/.col (right) -->
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-success">SAVE</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CANCEL
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="modal-xl2">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Master Fees Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="col-md-12">
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <form role="form">
                      <div class="row">
                        <div class="col-4">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >File Charge <span class="red">*</span></label
                            >
                            <input
                              v-model="form.fileCharge"
                              type="text"
                              name="fileCharge"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('fileCharge'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="fileCharge"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-4">
                          <!-- text input -->
                          <div class="form-group">
                            <label
                              >File Charge Type
                              <span class="red">*</span></label
                            >
                            <select
                              v-model="form.fileChargeType"
                              name="fileChargeType"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('fileChargeType'),
                              }"
                            >
                              <option value="fixed">Fixed</option>
                              <option value="percent">Percent</option>
                            </select>
                            <has-error
                              :form="form"
                              field="fileChargeType"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- /.card-body -->
                </div>
                <!-- /.card -->
              </div>
              <!--/.col (right) -->
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-success">SAVE</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CANCEL
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      

</div>
</template>

<script>
export default {
  name: 'FeeMaster',
  data () {
    return {
      form: new Form({
        inTime: '',
        outTime: '',
        status: false
      }),
      fees: {}
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('fee?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          loader.hide()
          this.fees = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// FeesMaster.vue?8ad84ee2